import classNames from 'classnames/bind';
import React from 'react';
import styles from './SubNav.module.scss';

const cx = classNames.bind(styles);

const getButtonStyles = (tab, selectedTab) => {
  return cx({
    Button: true,
    Active: tab === selectedTab,
  });
};

const SubNav = (props) => {
  const { selectedTab, setSelectedTab } = props;
  return (
    <div className={ styles.SubNav }>
      <button
        className={ getButtonStyles(0, selectedTab) }
        onClick={ () => setSelectedTab(0) }
        type="button"
      >
        For You
      </button>
      <button
        className={ getButtonStyles(1, selectedTab) }
        onClick={ () => setSelectedTab(1) }
        type="button"
      >
        Discover
      </button>
    </div>
  );
};
export default SubNav;
